import {Tooltip} from "antd";
import moment from 'moment';
import {ArrowRightOutlined} from "@ant-design/icons";
import BrowserRouter, {BrowserRoutes} from "../../../routes/BrowserRouter";
import {IOpportunity} from "../../../api/Opportunity/Opportunity.types";
import Link from "../../common/ExternalLink/ExternalLink";
import Button from "../../common/Button/Button";

export const OpportunitiesTableConfig = () => {
    return [
        {
            title: 'Solicitation Title',  dataIndex: 'title', key: 'title', ellipsis: {showTitle: false},
            render: (title) => {
                return (
                    <Tooltip title={title}>
                        {title}
                    </Tooltip>
                )
            }
        },
        {
            title: 'NAICS', dataIndex: 'naics', key: 'naics'
        },
        {
            title: 'Type', dataIndex: 'type', key: 'type',
        },
        {
            title: 'SAM Link', dataIndex: 'uiLink', key: 'uiLink', render: description => {
                return (
                    <Link text="SAM Link" link={description.replace('beta.', '')} external/>
                )
            }
        },
        {
            title: 'Response Date', dataIndex: 'responseDate', key: 'responseDate',
            render: responseDate => {
                if (responseDate) {
                    return moment(responseDate).format("MMM DD, YYYY")
                } else {
                    return null;
                }
            },
            sorter: (a,b) => {
                if (a && b){
                    return new Date(a.responseDate).getTime() - new Date(b.responseDate).getTime()
                } else {
                    return 0;
                }
            },
            // defaultSortOrder: "descend" as SortOrder
        },
        {
            title: 'Posted Date', dataIndex: 'postedDate', key: 'postedDate',
            render: postedDate => {
                if (postedDate) {
                    return moment(postedDate).format("MMM DD, YYYY")
                } else {
                    return null;
                }
            }
        },
        {
            key: 'actions', render: (opportunity: IOpportunity) => {
                return (
                    <div className='table-row-actions'>
                        <Button icon={<ArrowRightOutlined/>} iconPosition="right"
                                onClick={() => BrowserRouter.push(BrowserRoutes.getOpportunitiesById(opportunity.id))}>
                            Details
                        </Button>
                    </div>
                )
            }
        }
    ]
}